import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type AttachmentIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function AttachmentIcon({
  className,
  pathClassName = "stroke-teachLoop-textPrimary",
  ...props
}: AttachmentIconProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M12.947 7.308l-5.526 5.527a2.607 2.607 0 103.689 3.688l5.982-5.982a4.548 4.548 0 000-6.452 4.549 4.549 0 00-6.4.065l-6.034 5.918a6.517 6.517 0 009.215 9.215l7.377-7.312"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default AttachmentIcon;
